import { Injectable, Inject } from '@angular/core';
import { environment } from 'environments/environment';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})

/**
 * Servicio de Dominio de la aplicación
 * @author Iecisa
 */
export class DomainService {

    private _backendUrlWithContext: string;
    private _wordpressUrl: string;
    private _wordpressJuridicoUrl: string;
    private _frontEndUrl: string;

    constructor(@Inject(DOCUMENT) private document: Document) {

        this._backendUrlWithContext = environment.backendUrlWithContext;
        this._wordpressUrl = environment.wordpressUrl;
        this._wordpressJuridicoUrl = environment.wordpressJuridicoUrl;
        this._frontEndUrl = environment.frontEndUrl;

    }

    public get backendUrlWithContext(): string {
        return this._backendUrlWithContext;
    }

    public get frontEndUrl(): string{
        return this._frontEndUrl;
      }

    public get wordpressUrl(): string {
        return this._wordpressUrl;
    }

    public get wordpressJuridicoUrl(): string {
        return this._wordpressJuridicoUrl;
    }

}

